// extracted by mini-css-extract-plugin
export default {"container-vrm":"Reviews__container-vrm-FVR9","view":"Reviews__view-VHW8","wrapper":"Reviews__wrapper-R_ud","reviews":"Reviews__reviews-bTv7"};